import {cn} from "../../../../utils/utils";
import TmdbImage from "../../../shared/tmdb-image/tmdb-image";
import React from "react";
import CachedImage from "../../../shared/cached-image/cached-image";

type Props = {
    className?: string;
    style?: React.CSSProperties;
    disabled?: boolean;
    onClick?: () => void;
    title?: string;
    backgroundUrl: string;
    logoImageUrl?: string;
    logoSubtitle?: React.ReactNode;
    overlay?: {
        bottomLeft?: React.ReactNode;
        bottomRight?: React.ReactNode;
        TopRight?: React.ReactNode;
    }
}

const SquadflixHeaderItem = (props: Props) => {

    return (
        <button className={cn("squadflix-trending-header__item", props.className)}
                style={props.style} onClick={props.onClick}>
            {props.backgroundUrl?.startsWith("http") ?
                <CachedImage className="squadflix-trending-header__item-img"
                             src={props.backgroundUrl}/> :
                <TmdbImage className="squadflix-trending-header__item-img"
                           src={props.backgroundUrl}
                           size="original"/>}
            <div className={cn("squadflix-trending-header__item-overlay",
                props.disabled ? "fade-out-hidden" : "fade-in-delay")}>
                {props.logoImageUrl &&
                    <TmdbImage className="squadflix-trending-header__item-logo"
                               src={props.logoImageUrl}
                               size="w500"/>}
                <div className="squadflix-trending-header__item-subtitle">
                    {props.logoSubtitle}
                </div>
                {props.title && <div
                    className="squadflix-trending-header__item-title">{props.title}</div>}
                <div className="squadflix-trending-header__item-info">
                    {props.overlay?.bottomLeft}
                </div>
            </div>
        </button>
    );
}

export default SquadflixHeaderItem;